import React from 'react'
import PropTypes from 'prop-types'
import './PageHeader.scss'

export default function PageHeader({ title, date, banner }) {
  return (
    <header className={'PageHeader'}>
      <h1>{title}</h1>
      {date && (
        <div className={'meta'}>
          <time>{date}</time>
        </div>
      )}
      {banner && (
        <div className={'banner'}>
          <img src={banner} />
        </div>
      )}
    </header>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  banner: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/PageHeader.js